import{f as p}from"./LineSpacingPanel-963f8810.js";import"react";import"prop-types";import"wix-rich-content-common";import"classnames";const o={LINE_SPACING:"LINE_SPACING"},r={[o.LINE_SPACING]:p};export{o as Modals,r as ModalsMap};
//# sourceMappingURL=modals.js.map
